import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "store/store";
import { UserTypeEnum } from "common/enums/UserType.enum";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { userData } = useSelector((state: RootState) => state.auth);
  if (userData) {
    if (userData.type === UserTypeEnum.COMPANY_BUYER) {
      return <Navigate to="/buyer/dashboard" replace />;
    }
    if (userData.type === UserTypeEnum.COMPANY_SELLER) {
      return <Navigate to="/seller/dashboard" replace />;
    }
    if (userData.type === UserTypeEnum.ADMIN) {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  return <>{children}</>;
};

export default PublicRoute;
